// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__4zeBd","footer_icon":"Footer_footer_icon__GlL4i"};